export default "__VITE_ASSET__DlathqPK__"